import { PAGES } from '~/constants';
import { matchPath } from 'react-router';

const getActivePage = (pathname, exact = true) =>
	Object.values(PAGES).find(({ path }) => matchPath(pathname, { path, exact }));

export default getActivePage;
